import { ElementRef, NgZone, TemplateRef } from '@angular/core';
import { MessageService } from '../../message/message.service';
import { TrackerService } from '../../../core/tracker/tracker.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SRQCompletedService } from '../../srq-completed/srq-completed.service';
import { SessionStorageService } from 'ngx-webstorage';
import { QuestionarreAnswerService } from '../../questionarre-answer/questionarre-answer.service';
import { SessionService } from '../../session/session.service';
import { ActivatedRoute, Router } from "@angular/router";
import { SessionChatComponent } from '../../session/session-chat-coach/session-chat.component';
import { VideoCallService } from '../../video-call/video-call.service';
import { FlowManagerService } from '../../../core/util/flow-manager.service';
import { SessionTimeUtils } from '../../../core/util/SessionTimeUtils';
import { JhiAlertService, JhiEventManager } from '../../../ng-jhipster/service';
import * as i0 from "@angular/core";
import * as i1 from "../../session/session.service";
import * as i2 from "../../message/message.service";
import * as i3 from "../../srq-completed/srq-completed.service";
import * as i4 from "../../questionarre-answer/questionarre-answer.service";
import * as i5 from "@angular/router";
import * as i6 from "ngx-webstorage";
import * as i7 from "../../../core/tracker/tracker.service";
import * as i8 from "@ng-bootstrap/ng-bootstrap";
import * as i9 from "../../../ng-jhipster/service";
import * as i10 from "@ngx-translate/core";
import * as i11 from "../../video-call/video-call.service";
import * as i12 from "../../../core/util/flow-manager.service";
import * as i13 from "@angular/common";
import * as i14 from "../../../shared/alert/alert.component";
import * as i15 from "./scripts/scripts.component";
import * as i16 from "./session-control.component/session-control.component";
import * as i17 from "../chat-ui/message-send/session-message-send.component";
import * as i18 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i19 from "../../../shared/user-info/user-info.component";
import * as i20 from "../chat-ui-new/chat-ui-new.component";
import * as i21 from "./edit-action-plan/edit-action-plan.component";
import * as i22 from "@angular/material/tooltip";
import * as i23 from "./coach-user-note/coach-user-note.component";
import * as i24 from "./inuka-journey-coach-chat/inuka-journey-coach-chat.component";
import * as i25 from "@fortawesome/angular-fontawesome";
import * as i26 from "./previous-session-transcript-popup/previous-session-transcript-popup.component";
import * as i27 from "../../../shared/modal-success/modal-success.component";
import * as i28 from "../session-summary/session-summary.component";
const _c0 = ["sessionDoesNotExistModal"];
const _c1 = ["sessionEndedModal"];
const _c2 = ["emailSessionMessagesModal"];
const _c3 = ["sessionAboutToEnd"];
const _c4 = ["previousSessionTranscriptModal"];
function SessionChatCoachComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵelementStart(2, "scripts-component", 17);
    i0.ɵɵlistener("messageSelected", function SessionChatCoachComponent_div_3_Template_scripts_component_messageSelected_2_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.onScriptSelected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isMobile", false);
} }
function SessionChatCoachComponent_div_4_div_1_user_info_3_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "user-info", 37);
    i0.ɵɵlistener("onRightArrowClick", function SessionChatCoachComponent_div_4_div_1_user_info_3_Template_user_info_onRightArrowClick_0_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(3); return ctx_r28.switchViewMode("UserInfo"); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("session", ctx_r27.session)("user", ctx_r27.session.user)("srqHistory", ctx_r27.srqHistory)("minimized", true)("showRightArrow", true);
} }
const _c5 = function (a0) { return { "border-bottom": a0 }; };
const _c6 = function (a0) { return { "bg-success viewModeButtonActive": a0 }; };
function SessionChatCoachComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "div", 30);
    i0.ɵɵtemplate(3, SessionChatCoachComponent_div_4_div_1_user_info_3_Template, 1, 5, "user-info", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 32);
    i0.ɵɵelementStart(5, "div", 33);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_div_4_div_1_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(2); return ctx_r30.switchViewMode("Chat"); });
    i0.ɵɵelement(6, "h5", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 33);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_div_4_div_1_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.switchViewMode("ActionPlan"); });
    i0.ɵɵelement(8, "h5", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 33);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_div_4_div_1_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r31); const ctx_r33 = i0.ɵɵnextContext(2); return ctx_r33.switchViewMode("Notes"); });
    i0.ɵɵelement(10, "h5", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r22.session == null ? null : ctx_r22.session.user);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(5, _c5, ctx_r22.viewMode === "Chat" ? "0px solid" : "2px solid"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c6, ctx_r22.viewMode === "Chat"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c6, ctx_r22.viewMode === "ActionPlan"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c6, ctx_r22.viewMode === "Notes"));
} }
function SessionChatCoachComponent_div_4_chat_ui_new_8_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "chat-ui-new", 38);
    i0.ɵɵlistener("repliedMessage", function SessionChatCoachComponent_div_4_chat_ui_new_8_Template_chat_ui_new_repliedMessage_0_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(2); return ctx_r34.repliedMessage($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("viewportHeight", "100%")("session", ctx_r23.session)("displayingPastSession", false);
} }
function SessionChatCoachComponent_div_4_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵelementStart(2, "div", 41);
    i0.ɵɵelement(3, "edit-action-plan", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("session", ctx_r24.session)("disabled", !ctx_r24.session.started);
} }
function SessionChatCoachComponent_div_4_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelementStart(1, "div", 43);
    i0.ɵɵelementStart(2, "div", 44);
    i0.ɵɵelementStart(3, "div", 45);
    i0.ɵɵelementStart(4, "div", 46);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_div_4_div_11_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(2); return ctx_r36.goToLink("/#/notes/" + ctx_r36.session.user.id + "/" + ctx_r36.session.coachId); });
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(6, "svg", 47);
    i0.ɵɵelement(7, "use", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(8, "coach-user-note", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(5, 6, "sessionChat.paragraph.expandInfoNotes"))("matTooltipPosition", "below")("matTooltipClass", "expand-tool-tip");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("isEmbedded", true)("userId", ctx_r25.session == null ? null : ctx_r25.session.user.id)("coachId", ctx_r25.coach.id);
} }
function SessionChatCoachComponent_div_4_div_12_user_info_5_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "user-info", 62);
    i0.ɵɵlistener("onLeftArrowClick", function SessionChatCoachComponent_div_4_div_12_user_info_5_Template_user_info_onLeftArrowClick_0_listener() { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(3); return ctx_r42.switchViewMode("Chat"); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("session", ctx_r38.session)("user", ctx_r38.session.user)("srqHistory", ctx_r38.srqHistory)("showLeftArrow", true);
} }
function SessionChatCoachComponent_div_4_div_12__svg_use_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 63);
} }
function SessionChatCoachComponent_div_4_div_12__svg_use_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 64);
} }
function SessionChatCoachComponent_div_4_div_12_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "div", 66);
    i0.ɵɵelementStart(2, "div", 43);
    i0.ɵɵelementStart(3, "div", 67);
    i0.ɵɵelementStart(4, "inuka-journey-coach-chat", 68);
    i0.ɵɵlistener("sessionSelectedToOpenInThisTab", function SessionChatCoachComponent_div_4_div_12_div_16_Template_inuka_journey_coach_chat_sessionSelectedToOpenInThisTab_4_listener($event) { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(3); return ctx_r44.showPreviousSessionTranscriptInThisTab($event); })("sessionSelectedToOpenInNewTab", function SessionChatCoachComponent_div_4_div_12_div_16_Template_inuka_journey_coach_chat_sessionSelectedToOpenInNewTab_4_listener($event) { i0.ɵɵrestoreView(_r45); const ctx_r46 = i0.ɵɵnextContext(3); return ctx_r46.showPreviousSessionTranscriptInNewTab($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("sessions", ctx_r41.userAllSessions)("srqHistory", ctx_r41.srqHistory);
} }
function SessionChatCoachComponent_div_4_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵelementStart(2, "div", 41);
    i0.ɵɵelementStart(3, "div", 50);
    i0.ɵɵelementStart(4, "div", 30);
    i0.ɵɵtemplate(5, SessionChatCoachComponent_div_4_div_12_user_info_5_Template, 1, 4, "user-info", 51);
    i0.ɵɵelement(6, "hr", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 53);
    i0.ɵɵelementStart(8, "div", 54);
    i0.ɵɵelementStart(9, "a", 55);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_div_4_div_12_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r48); const ctx_r47 = i0.ɵɵnextContext(2); return ctx_r47.toggleUserJourney(); });
    i0.ɵɵtext(10, "Journey");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 56);
    i0.ɵɵelementStart(12, "a", 57);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_div_4_div_12_Template_a_click_12_listener() { i0.ɵɵrestoreView(_r48); const ctx_r49 = i0.ɵɵnextContext(2); return ctx_r49.toggleUserJourney(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(13, "svg", 58);
    i0.ɵɵtemplate(14, SessionChatCoachComponent_div_4_div_12__svg_use_14_Template, 1, 0, "use", 59);
    i0.ɵɵtemplate(15, SessionChatCoachComponent_div_4_div_12__svg_use_15_Template, 1, 0, "use", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, SessionChatCoachComponent_div_4_div_12_div_16_Template, 5, 2, "div", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r26.session == null ? null : ctx_r26.session.user);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", !ctx_r26.showUserJourney);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r26.showUserJourney);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r26.showUserJourney && ctx_r26.userAllSessions && ctx_r26.srqHistory);
} }
function SessionChatCoachComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, SessionChatCoachComponent_div_4_div_1_Template, 11, 13, "div", 19);
    i0.ɵɵelementStart(2, "div", 20);
    i0.ɵɵelementStart(3, "div", 21);
    i0.ɵɵelementStart(4, "div", 22);
    i0.ɵɵelementStart(5, "div", 21);
    i0.ɵɵelementStart(6, "session-control", 23);
    i0.ɵɵlistener("resourceSelected", function SessionChatCoachComponent_div_4_Template_session_control_resourceSelected_6_listener($event) { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(); return ctx_r50.onResourceSelected($event); })("displayScriptComponent", function SessionChatCoachComponent_div_4_Template_session_control_displayScriptComponent_6_listener() { i0.ɵɵrestoreView(_r51); const ctx_r52 = i0.ɵɵnextContext(); const _r3 = i0.ɵɵreference(7); return ctx_r52.open(_r3); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 24);
    i0.ɵɵtemplate(8, SessionChatCoachComponent_div_4_chat_ui_new_8_Template, 1, 3, "chat-ui-new", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "session-message-send", 26);
    i0.ɵɵlistener("scriptsModalClicked", function SessionChatCoachComponent_div_4_Template_session_message_send_scriptsModalClicked_9_listener() { i0.ɵɵrestoreView(_r51); const ctx_r53 = i0.ɵɵnextContext(); const _r3 = i0.ɵɵreference(7); return ctx_r53.open(_r3); })("focusIn", function SessionChatCoachComponent_div_4_Template_session_message_send_focusIn_9_listener() { i0.ɵɵrestoreView(_r51); const ctx_r54 = i0.ɵɵnextContext(); return ctx_r54.onMessageSendTextboxFocusIn(); })("focusOut", function SessionChatCoachComponent_div_4_Template_session_message_send_focusOut_9_listener() { i0.ɵɵrestoreView(_r51); const ctx_r55 = i0.ɵɵnextContext(); return ctx_r55.onMessageSendTextboxFocusOut(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, SessionChatCoachComponent_div_4_div_10_Template, 4, 2, "div", 27);
    i0.ɵɵtemplate(11, SessionChatCoachComponent_div_4_div_11_Template, 9, 8, "div", 27);
    i0.ɵɵtemplate(12, SessionChatCoachComponent_div_4_div_12_Template, 17, 4, "div", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.viewMode !== "UserInfo");
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("height", !ctx_r1.collapsedMode ? "85%" : "100%");
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("d-none", ctx_r1.viewMode !== "Chat" && !ctx_r1.isScreenXLg);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("session", ctx_r1.session);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.session);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("session", ctx_r1.session)("message", ctx_r1.message)("maxCharacterSize", 3000)("messageToBeReplied", ctx_r1.messageToBeReplied);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.viewMode == "ActionPlan" && ctx_r1.session && !ctx_r1.isScreenXLg);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.viewMode == "Notes" && ctx_r1.session && !ctx_r1.isScreenXLg);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.viewMode === "UserInfo" && !ctx_r1.isScreenXLg);
} }
function SessionChatCoachComponent_div_5_user_info_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "user-info", 80);
} if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("session", ctx_r56.session)("user", ctx_r56.session.user)("srqHistory", ctx_r56.srqHistory);
} }
function SessionChatCoachComponent_div_5__svg_use_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 63);
} }
function SessionChatCoachComponent_div_5__svg_use_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 64);
} }
function SessionChatCoachComponent_div_5_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "div", 66);
    i0.ɵɵelementStart(2, "div", 43);
    i0.ɵɵelementStart(3, "div", 67);
    i0.ɵɵelementStart(4, "inuka-journey-coach-chat", 68);
    i0.ɵɵlistener("sessionSelectedToOpenInThisTab", function SessionChatCoachComponent_div_5_div_15_Template_inuka_journey_coach_chat_sessionSelectedToOpenInThisTab_4_listener($event) { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(2); return ctx_r61.showPreviousSessionTranscriptInThisTab($event); })("sessionSelectedToOpenInNewTab", function SessionChatCoachComponent_div_5_div_15_Template_inuka_journey_coach_chat_sessionSelectedToOpenInNewTab_4_listener($event) { i0.ɵɵrestoreView(_r62); const ctx_r63 = i0.ɵɵnextContext(2); return ctx_r63.showPreviousSessionTranscriptInNewTab($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("sessions", ctx_r59.userAllSessions)("srqHistory", ctx_r59.srqHistory);
} }
function SessionChatCoachComponent_div_5_div_23_edit_action_plan_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "edit-action-plan", 42);
} if (rf & 2) {
    const ctx_r64 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("session", ctx_r64.session)("disabled", !ctx_r64.session.started);
} }
function SessionChatCoachComponent_div_5_div_23_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 85);
    i0.ɵɵelementStart(1, "div", 45);
    i0.ɵɵelementStart(2, "div", 86);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_div_5_div_23_div_4_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r67); const ctx_r66 = i0.ɵɵnextContext(3); return ctx_r66.goToLink("/#/notes/" + ctx_r66.session.user.id + "/" + ctx_r66.session.coachId); });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 47);
    i0.ɵɵelement(5, "use", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(6, "coach-user-note", 49);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r65 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(3, 6, "sessionChat.paragraph.expandInfoNotes"))("matTooltipPosition", "below")("matTooltipClass", "expand-tool-tip");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("isEmbedded", true)("userId", ctx_r65.session == null ? null : ctx_r65.session.user.id)("coachId", ctx_r65.coach.id);
} }
function SessionChatCoachComponent_div_5_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 81);
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵelementStart(2, "div", 82);
    i0.ɵɵtemplate(3, SessionChatCoachComponent_div_5_div_23_edit_action_plan_3_Template, 1, 2, "edit-action-plan", 83);
    i0.ɵɵtemplate(4, SessionChatCoachComponent_div_5_div_23_div_4_Template, 7, 8, "div", 84);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r60.rightColumnTab === "ActionPlan");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r60.rightColumnTab === "Notes");
} }
const _c7 = function (a0) { return { "height": a0 }; };
function SessionChatCoachComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵelementStart(1, "div", 70);
    i0.ɵɵelementStart(2, "div", 50);
    i0.ɵɵelementStart(3, "div", 30);
    i0.ɵɵtemplate(4, SessionChatCoachComponent_div_5_user_info_4_Template, 1, 3, "user-info", 71);
    i0.ɵɵelement(5, "hr", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 72);
    i0.ɵɵelementStart(7, "div", 54);
    i0.ɵɵelementStart(8, "a", 55);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_div_5_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r69); const ctx_r68 = i0.ɵɵnextContext(); return ctx_r68.toggleUserJourney(); });
    i0.ɵɵtext(9, "Journey");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 56);
    i0.ɵɵelementStart(11, "a", 57);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_div_5_Template_a_click_11_listener() { i0.ɵɵrestoreView(_r69); const ctx_r70 = i0.ɵɵnextContext(); return ctx_r70.toggleUserJourney(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(12, "svg", 58);
    i0.ɵɵtemplate(13, SessionChatCoachComponent_div_5__svg_use_13_Template, 1, 0, "use", 59);
    i0.ɵɵtemplate(14, SessionChatCoachComponent_div_5__svg_use_14_Template, 1, 0, "use", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, SessionChatCoachComponent_div_5_div_15_Template, 5, 2, "div", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(16, "div", 73);
    i0.ɵɵelementStart(17, "div", 50);
    i0.ɵɵelementStart(18, "div", 74);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_div_5_Template_div_click_18_listener() { i0.ɵɵrestoreView(_r69); const ctx_r71 = i0.ɵɵnextContext(); return ctx_r71.switchRightColumnTab("ActionPlan"); });
    i0.ɵɵelement(19, "h5", 75);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 76);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_div_5_Template_div_click_20_listener() { i0.ɵɵrestoreView(_r69); const ctx_r72 = i0.ɵɵnextContext(); return ctx_r72.switchRightColumnTab("Notes"); });
    i0.ɵɵelement(21, "h5", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(22, "hr", 78);
    i0.ɵɵtemplate(23, SessionChatCoachComponent_div_5_div_23_Template, 5, 2, "div", 79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c7, ctx_r2.showUserJourney ? "50%" : "20%"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.session == null ? null : ctx_r2.session.user);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", !ctx_r2.showUserJourney);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showUserJourney);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showUserJourney && ctx_r2.userAllSessions && ctx_r2.srqHistory);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(11, _c7, ctx_r2.showUserJourney ? "48%" : "78%"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c6, ctx_r2.rightColumnTab === "ActionPlan"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c6, ctx_r2.rightColumnTab === "Notes"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.session);
} }
function SessionChatCoachComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelementStart(1, "div", 87);
    i0.ɵɵelementStart(2, "fa-icon", 88);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_ng_template_6_Template_fa_icon_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r75); const modal_r73 = restoredCtx.$implicit; return modal_r73.dismiss("Cross click"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 89);
    i0.ɵɵelementStart(4, "scripts-component", 17);
    i0.ɵɵlistener("messageSelected", function SessionChatCoachComponent_ng_template_6_Template_scripts_component_messageSelected_4_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r75); const modal_r73 = restoredCtx.$implicit; const ctx_r76 = i0.ɵɵnextContext(); ctx_r76.onScriptSelected($event); return modal_r73.dismiss(""); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("isMobile", true);
} }
function SessionChatCoachComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r79 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelementStart(1, "div", 87);
    i0.ɵɵelementStart(2, "fa-icon", 88);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_ng_template_8_Template_fa_icon_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r79); const modal_r77 = restoredCtx.$implicit; return modal_r77.dismiss("Cross click"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 90);
    i0.ɵɵelement(4, "previous-session-transcript-popup", 91);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("showInModal", true)("session", ctx_r6.previousSessionToShowTranscript);
} }
function SessionChatCoachComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r82 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelementStart(1, "div", 93);
    i0.ɵɵelement(2, "div", 94);
    i0.ɵɵelementStart(3, "button", 95);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_ng_template_10_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r82); const ctx_r81 = i0.ɵɵnextContext(); return ctx_r81.dismissAll(); });
    i0.ɵɵelementStart(4, "span", 96);
    i0.ɵɵtext(5, "\u00D7");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "edit-action-plan", 97);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("session", ctx_r8.session);
} }
const _c8 = function (a0) { return { param: a0 }; };
function SessionChatCoachComponent_ng_template_12_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 102);
} if (rf & 2) {
    const ctx_r84 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("jhiTranslate", ctx_r84.endsIn)("translateValues", i0.ɵɵpureFunction1(2, _c8, ctx_r84.endsInParam));
} }
function SessionChatCoachComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    const _r86 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 98);
    i0.ɵɵtemplate(1, SessionChatCoachComponent_ng_template_12_div_1_Template, 1, 4, "div", 99);
    i0.ɵɵelementStart(2, "div", 100);
    i0.ɵɵelementStart(3, "a", 101);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_ng_template_12_Template_a_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r86); const modal_r83 = restoredCtx.$implicit; return modal_r83.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.endsIn && ctx_r10.endsInParam);
} }
const _c9 = function (a0) { return { secondsLeft: a0 }; };
function SessionChatCoachComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    const _r89 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 98);
    i0.ɵɵelement(1, "div", 103);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelementStart(3, "a", 104);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_ng_template_14_Template_a_click_3_listener() { i0.ɵɵrestoreView(_r89); const ctx_r88 = i0.ɵɵnextContext(); return ctx_r88.extendSessionByTenMinutes(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 105);
    i0.ɵɵlistener("click", function SessionChatCoachComponent_ng_template_14_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r89); const ctx_r90 = i0.ɵɵnextContext(); return ctx_r90.dismissCountDownModal(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c9, ctx_r12.secondsLeft));
} }
function SessionChatCoachComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 106);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("message", i0.ɵɵpipeBind1(1, 2, "sessionChat.messages.active"))("navigateTo", "index-coach");
} }
function SessionChatCoachComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r93 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 107);
    i0.ɵɵelementStart(1, "session-summary", 108);
    i0.ɵɵlistener("closeSessionSummaryOutput", function SessionChatCoachComponent_div_18_Template_session_summary_closeSessionSummaryOutput_1_listener($event) { i0.ɵɵrestoreView(_r93); const ctx_r92 = i0.ɵɵnextContext(); return ctx_r92.onCloseSessionSummary($event); })("hideSessionSummaryOutput", function SessionChatCoachComponent_div_18_Template_session_summary_hideSessionSummaryOutput_1_listener($event) { i0.ɵɵrestoreView(_r93); const ctx_r94 = i0.ɵɵnextContext(); return ctx_r94.onHideSessionSummary($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showSessionSummary", ctx_r15.showSessionSummary)("sessionId", ctx_r15.session.id);
} }
function SessionChatCoachComponent_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 109);
} if (rf & 2) {
    i0.ɵɵproperty("navigateTo", "index-coach");
} }
function SessionChatCoachComponent_ng_template_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 110);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵproperty("titleText", "sessionChat.header.selectedMessages")("message", i0.ɵɵpipeBind1(1, 2, ctx_r19.emailSessionMessagesModalMessage));
} }
const _c10 = function (a0) { return { "opacity": a0 }; };
export class SessionChatCoachComponent extends SessionChatComponent {
    constructor(sessionService, messageService, srqCompletedService, questionarreAnswerService, route, sessionStorage, trackerService, modalService, alertService, translate, ngZone, elementRef, eventManager, router, videoCallService, flowManagerService) {
        super(messageService, alertService, sessionStorage, sessionService, modalService, ngZone);
        this.sessionService = sessionService;
        this.messageService = messageService;
        this.srqCompletedService = srqCompletedService;
        this.questionarreAnswerService = questionarreAnswerService;
        this.route = route;
        this.sessionStorage = sessionStorage;
        this.trackerService = trackerService;
        this.modalService = modalService;
        this.alertService = alertService;
        this.translate = translate;
        this.ngZone = ngZone;
        this.elementRef = elementRef;
        this.eventManager = eventManager;
        this.router = router;
        this.videoCallService = videoCallService;
        this.flowManagerService = flowManagerService;
        this.message = '';
        this.messagesList = [];
        this.hideContent = false;
        this.showUserJourney = false;
        this.viewMode = 'Chat';
        this.rightColumnTab = 'ActionPlan';
        this.display = "";
        this.secondsLeft = 60;
        this.secondsLeftDisplayed = false;
    }
    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#F7F4EB';
        this.display = this.route.snapshot.params["display"];
        // if (this.display === "past") {
        //   this.secondColumnContent = this.dropDownOptions[1];
        // }
        this.sessionIdFromUrl = this.route.snapshot.params["sessionId"];
        // get current session and coach data
        // get past messages
        this.messageService.getSession(this.sessionIdFromUrl).subscribe((res1) => {
            this.onSuccess(res1.body);
        }, err => this.onError(err));
        this.eventManager.subscribe('collapsedModeEnabled', () => {
            this.collapsedMode = true;
        });
        this.eventManager.subscribe('collapsedModeDisabled', () => {
            this.collapsedMode = false;
        });
        this.organizationResourceSubscription = this.eventManager.subscribe('organizationResourceSelected', (response) => {
            console.log(response);
            this.message = response.content;
        });
        this.subscribeToWebsocket();
    }
    checkToShowSubmitSessionSummaryPopup(session) {
        if (session.ended && session.attendanceType === 'ALL_ATTENDED') {
            this.sessionService.getSessionSummaryBySessionId(session.id).subscribe((res) => {
                let sessionSummary = res.body;
            }, (errorResponse) => {
                console.log(errorResponse);
                // if there is no session summary
                if (SessionTimeUtils.calculateMinutesPassedFromSessionEndTime(session) <= 60) {
                    this.showSessionSummary = true;
                }
            });
        }
    }
    onSuccess(body) {
        this.checkToShowSubmitSessionSummaryPopup(body);
        this.setSessionAndActionPlan(body);
        this.coach = this.session.coach;
        this.srqCompletedService.srqHistoryByUser(this.session.user.id).subscribe((res) => {
            this.srqHistory = res.body;
        });
        // this.fetchEndedSessions();
        this.updateMinutesLeftRecurring(2);
    }
    onError(err) {
        console.log('error occured: ' + JSON.stringify(err.status));
        if (err.status === 404) {
            this.modalService.open(this.sessionDoesNotExistModal);
        }
    }
    subscribeToWebsocket() {
        this.subscription = this.trackerService.listenerSubject.subscribe(value => {
            const message = value['body'];
            const type = value['type'];
            if (type === 'SESSION_STATUS_CHANGED') {
                let s = message;
                // console.log('SESSION_STATUS_CHANGED: ' + s.id);
                if (this.session.id === s.id) {
                    this.messageService.getSession(this.session.id).subscribe((res1) => {
                        this.onSuccess(res1.body);
                    });
                    // this.open(this.sessionEndedModal);
                }
            }
            else if (type === 'SESSION_EXTENDED') {
                this.session.duration = message['duration'];
                this.updateMinutesLeft();
            }
            else {
                console.log('SessionChatCoachComponent ignoring ' + type + ' message');
            }
        });
    }
    onScriptSelected($event) {
        // console.log('onScriptSelected:' + $event.script);
        this.message = '';
        setTimeout(() => {
            // console.log("setTimeout 2: " + $event.script);
            this.message = $event.script;
        }, 0);
    }
    onResourceSelected($event) {
        this.message = '';
        setTimeout(() => {
            this.message = $event.resource;
        }, 0);
    }
    setSessionAndActionPlan(s) {
        this.session = s;
        this.updateMinutesLeft();
    }
    displayCountdownModal() {
        if (this.secondsLeftDisplayed) {
            console.log("count down modal already displayed.");
            return;
        }
        else {
            console.log("count down modal will be displayed.");
            this.secondsLeftDisplayed = true;
        }
        this.ngbModalRef = this.modalService.open(this.sessionAboutToEnd);
        this.updateSecondsLeftRecurring();
    }
    updateSecondsLeftRecurring() {
        this.updateSecondsLeftRecurringHandle = setTimeout(() => {
            console.log("setTimeout 2: " + this.secondsLeft);
            if (this.secondsLeft > 0) {
                this.secondsLeft--;
                this.updateSecondsLeftRecurring();
            }
            else {
                this.ngbModalRef.close();
            }
        }, 1000);
    }
    extendSessionByTenMinutes() {
        this.sessionService.extendSession(this.session.id).subscribe(s => {
            this.session = s;
            this.dismissCountDownModal();
        });
    }
    dismissCountDownModal() {
        this.secondsLeftDisplayed = false;
        this.ngbModalRef.close();
        clearTimeout(this.updateSecondsLeftRecurringHandle);
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.messagesListSubscription) {
            this.messagesListSubscription.unsubscribe();
        }
        if (this.organizationResourceSubscription) {
            this.organizationResourceSubscription.unsubscribe();
        }
        if (this.updateMinutesLeftRecurringHandle) {
            clearInterval(this.updateMinutesLeftRecurringHandle);
        }
        if (this.updateSecondsLeftRecurringHandle) {
            clearTimeout(this.updateSecondsLeftRecurringHandle);
        }
    }
    repliedMessage(message) {
        this.messageToBeReplied = message;
        console.log(this.messageToBeReplied);
    }
    getCommentLength(field) {
        return !field ? 0 : field.length;
    }
    onMessageSendTextboxFocusIn() {
        if (!this.isScreenLg) {
            this.eventManager.broadcast('collapsedModeEnabled');
        }
    }
    onMessageSendTextboxFocusOut() {
        if (!this.isScreenLg) {
            this.eventManager.broadcast('collapsedModeDisabled');
        }
    }
    toggleUserJourney() {
        this.showUserJourney = !this.showUserJourney;
        if (this.showUserJourney && !this.userAllSessions) {
            this.loadAllSessions();
        }
    }
    loadAllSessions() {
        this.sessionService.getSessionsByUserId(this.session.user.id).subscribe((sessions) => {
            this.userAllSessions = sessions.body;
        });
    }
    switchViewMode(newMode) {
        if (newMode === 'UserInfo' && !this.userAllSessions) {
            this.toggleUserJourney();
        }
        this.viewMode = newMode;
    }
    switchRightColumnTab(selectedTab) {
        this.rightColumnTab = selectedTab;
    }
    showPreviousSessionTranscriptInThisTab(session) {
        this.previousSessionToShowTranscript = session;
        this.ngbModalRef = this.modalService.open(this.previousSessionTranscriptModal, { size: 'xl' });
    }
    showPreviousSessionTranscriptInNewTab(session) {
        // this.router.navigate(['/past',session.id]);
        this.router.navigate([]).then(result => { window.open('/#/past/' + session.id, '_blank'); });
    }
    onCloseSessionSummary(e) {
        this.showSessionSummary = e;
    }
    onHideSessionSummary(e) {
        this.hideContent = e;
    }
    goToLink(link) {
        window.open(link, '_blank');
    }
}
SessionChatCoachComponent.ɵfac = function SessionChatCoachComponent_Factory(t) { return new (t || SessionChatCoachComponent)(i0.ɵɵdirectiveInject(i1.SessionService), i0.ɵɵdirectiveInject(i2.MessageService), i0.ɵɵdirectiveInject(i3.SRQCompletedService), i0.ɵɵdirectiveInject(i4.QuestionarreAnswerService), i0.ɵɵdirectiveInject(i5.ActivatedRoute), i0.ɵɵdirectiveInject(i6.SessionStorageService), i0.ɵɵdirectiveInject(i7.TrackerService), i0.ɵɵdirectiveInject(i8.NgbModal), i0.ɵɵdirectiveInject(i9.JhiAlertService), i0.ɵɵdirectiveInject(i10.TranslateService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i9.JhiEventManager), i0.ɵɵdirectiveInject(i5.Router), i0.ɵɵdirectiveInject(i11.VideoCallService), i0.ɵɵdirectiveInject(i12.FlowManagerService)); };
SessionChatCoachComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SessionChatCoachComponent, selectors: [["session-chat-coach"]], viewQuery: function SessionChatCoachComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c4, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sessionDoesNotExistModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sessionEndedModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emailSessionMessagesModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sessionAboutToEnd = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.previousSessionTranscriptModal = _t.first);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 24, vars: 7, consts: [[1, "olha-theme"], [1, "px-3", "coach-session-chat-container", "session-chat-container", "pb-lg-2", 3, "ngStyle"], [1, "row", "justify-content-center", "h-100", 2, "position", "relative"], ["class", "col-xl-3 pl-xl-4 pr-xl-3", 4, "ngIf"], ["class", "col-12 col-xl-6 px-0 px-xl-2", 4, "ngIf"], ["class", "col-12 col-xl-3 pr-xl-4 pl-xl-3", 4, "ngIf"], ["scriptsModal", ""], ["previousSessionTranscriptModal", ""], ["actionPlanModal", ""], ["sessionEndsIn", ""], ["sessionAboutToEnd", ""], ["sessionDoesNotExistModal", ""], ["role", "dialog", "aria-labelledby", "myBasicModalLabel", "aria-hidden", "true", "style", "z-index: 1000; position: absolute; left: 0; right: 0; top: 10px; margin: 0 auto;", 4, "ngIf"], ["sessionEndedModal", ""], ["emailSessionMessagesModal", ""], [1, "col-xl-3", "pl-xl-4", "pr-xl-3"], [1, "h-100", "d-flex", "flex-column", "p-1"], [3, "isMobile", "messageSelected"], [1, "col-12", "col-xl-6", "px-0", "px-xl-2"], ["class", "d-flex flex-column p-0 mb-xl-3 d-xl-none session-chat-header", 4, "ngIf"], [1, "d-flex", "flex-column", "view-mode-parent"], [2, "position", "relative", "flex", "1 1 0"], [2, "position", "absolute", "left", "0", "right", "0", "display", "flex", "flex-direction", "column", "height", "100%"], [3, "session", "resourceSelected", "displayScriptComponent"], [1, "chat-container-coach", "p-1", 2, "position", "absolute", "left", "0", "right", "0", "display", "flex", "flex-direction", "column"], ["style", "height: 100%", 3, "viewportHeight", "session", "displayingPastSession", "repliedMessage", 4, "ngIf"], [3, "session", "message", "maxCharacterSize", "messageToBeReplied", "scriptsModalClicked", "focusIn", "focusOut"], ["class", "p-1", "style", "position: relative; flex: 1 1 0;", 4, "ngIf"], [1, "d-flex", "flex-column", "p-0", "mb-xl-3", "d-xl-none", "session-chat-header"], [1, "row", "m-0", "pb-2"], [1, "col", "p-0"], [3, "session", "user", "srqHistory", "minimized", "showRightArrow", "onRightArrowClick", 4, "ngIf"], [1, "row", "m-0", "text-center", "border-primary", 2, "border-top", "2px solid", 3, "ngStyle"], [1, "col", "px-2", "py-3", 3, "ngClass", "click"], ["jhiTranslate", "sessionChat.button.chat", 1, "mb-0", "w-100", "text-center", "font-weight-bold"], ["jhiTranslate", "sessionChat.button.actionPlan", 1, "mb-0", "w-100", "text-center", "font-weight-bold"], ["jhiTranslate", "sessionChat.button.notes", 1, "mb-0", "w-100", "text-center", "font-weight-bold"], [3, "session", "user", "srqHistory", "minimized", "showRightArrow", "onRightArrowClick"], [2, "height", "100%", 3, "viewportHeight", "session", "displayingPastSession", "repliedMessage"], [1, "p-1", 2, "position", "relative", "flex", "1 1 0"], [2, "position", "absolute", "right", "0", "left", "0", "display", "flex", "flex-direction", "column", "height", "100%"], [1, "flex-grow-1", "py-3", 2, "overflow-y", "scroll", "overflow-x", "hidden"], [3, "session", "disabled"], [2, "position", "absolute", "right", "0", "left", "0", "display", "flex", "flex-direction", "column", "height", "95%"], [1, "flex-grow-1", "py-3", "pr-3", "pl-3", 2, "overflow", "hidden"], [1, "d-flex", "align-items-center", "justify-content-end", "pr-4"], ["id", "user-home-expand-chat-btn", 1, "expand-div", 3, "matTooltip", "matTooltipPosition", "matTooltipClass", "click"], [1, "expand", 2, "width", "1.2rem!important", "height", "1.2rem!important"], [0, "xlink", "href", "../../../../../../../../../../../../content/images/sprite.svg?v=3#expand"], [3, "isEmbedded", "userId", "coachId"], [1, "row", "m-0"], [3, "session", "user", "srqHistory", "showLeftArrow", "onLeftArrowClick", 4, "ngIf"], [1, "my-0", "mx-4", 2, "border-top", "1px solid #DFF1EC"], [1, "row", "m-0", "px-2", "pt-3", "justify-content-around"], [1, "col"], ["jhiTranslate", "inukaNgApp.inukaJourney.journey", 1, "text-success", "h4", 3, "click"], [1, "col", "text-right"], [3, "click"], [1, "angle-icon", 2, "height", "22px", "width", "22px"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-down", 4, "ngIf"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-up", 4, "ngIf"], ["class", "row m-0", "style", "height: 60%;", 4, "ngIf"], [3, "session", "user", "srqHistory", "showLeftArrow", "onLeftArrowClick"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-down"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-up"], [1, "row", "m-0", 2, "height", "60%"], [2, "position", "relative", "flex", "1 1 0", "height", "100%"], [1, "flex-grow-1", "py-0", 2, "overflow-y", "scroll", "overflow-x", "hidden", "height", "100%"], [3, "sessions", "srqHistory", "sessionSelectedToOpenInThisTab", "sessionSelectedToOpenInNewTab"], [1, "col-12", "col-xl-3", "pr-xl-4", "pl-xl-3"], [1, "d-flex", "flex-column", "p-0", "mb-3", 2, "overflow-y", "scroll", 3, "ngStyle"], [3, "session", "user", "srqHistory", 4, "ngIf"], [1, "row", "m-0", "px-2", "pt-2", "justify-content-around"], [1, "d-flex", "flex-column", "p-0", 3, "ngStyle"], [1, "col", "px-2", "py-3", "pointer", 2, "border-radius", "20px 0 0 0", 3, "ngClass", "click"], ["jhiTranslate", "sessionChat.button.actionPlan", 1, "mb-0", "w-100", "text-center"], [1, "col", "px-2", "py-3", "pointer", 2, "border-radius", "0 20px 0 0", 3, "ngClass", "click"], ["jhiTranslate", "sessionChat.button.notes", 1, "mb-0", "w-100", "text-center"], [1, "m-0"], ["class", "", "style", "position: relative; flex: 1 1 0;", 4, "ngIf"], [3, "session", "user", "srqHistory"], [1, "", 2, "position", "relative", "flex", "1 1 0"], [1, "flex-grow-1", "py-3", "pr-2", "pl-3", 2, "overflow-y", "scroll", "overflow-x", "hidden"], [3, "session", "disabled", 4, "ngIf"], ["style", "height: 95%", 4, "ngIf"], [2, "height", "95%"], [1, "expand-div", 3, "matTooltip", "matTooltipPosition", "matTooltipClass", "click"], [1, "d-flex", "justify-content-end"], ["icon", "times-circle", 1, "mt-3", "mr-3", 2, "cursor", "pointer", 3, "click"], [1, "modal-body", 2, "height", "500px"], [1, "modal-body", 2, "height", "830px"], [3, "showInModal", "session"], [1, "h-100", "d-flex", "flex-column", "p-1", "fade-in", 2, "max-height", "590px"], [1, "modal-header"], ["jhiTranslate", "sessionChat.paragraph.plan", 1, "modal-title"], ["type", "button", "data-dismiss", "modal", "aria-hidden", "true", 1, "close", 3, "click"], ["aria-hidden", "true"], [3, "session"], [1, "modal-body"], ["class", "text-center m-4", 3, "jhiTranslate", "translateValues", 4, "ngIf"], [1, "text-center"], ["jhiTranslate", "sessionChat.Back to session", 1, "btn-2", "btn-2-success", "font-weight-bold", "voucher-apply-button", 3, "click"], [1, "text-center", "m-4", 3, "jhiTranslate", "translateValues"], ["jhiTranslate", "sessionChat.Session is about to end", 1, "text-center", "m-4", 3, "translateValues"], ["jhiTranslate", "sessionChat.Give me 10 more minutes", 1, "btn-2", "btn-2-success", "font-weight-bold", "float-left", 3, "click"], ["jhiTranslate", "sessionChat.Back to session", 1, "btn-2", "btn-2-success", "font-weight-bold", "voucher-apply-button", "float-right", 3, "click"], [3, "titleText", "message", "navigateTo"], ["role", "dialog", "aria-labelledby", "myBasicModalLabel", "aria-hidden", "true", 2, "z-index", "1000", "position", "absolute", "left", "0", "right", "0", "top", "10px", "margin", "0 auto"], [3, "showSessionSummary", "sessionId", "closeSessionSummaryOutput", "hideSessionSummaryOutput"], ["titleText", "Session Ended", "message", "Session Ended", 3, "navigateTo"], [3, "titleText", "message"]], template: function SessionChatCoachComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, SessionChatCoachComponent_div_3_Template, 3, 1, "div", 3);
        i0.ɵɵtemplate(4, SessionChatCoachComponent_div_4_Template, 13, 14, "div", 4);
        i0.ɵɵtemplate(5, SessionChatCoachComponent_div_5_Template, 24, 17, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, SessionChatCoachComponent_ng_template_6_Template, 5, 1, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(8, SessionChatCoachComponent_ng_template_8_Template, 5, 2, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(10, SessionChatCoachComponent_ng_template_10_Template, 7, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(12, SessionChatCoachComponent_ng_template_12_Template, 4, 1, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(14, SessionChatCoachComponent_ng_template_14_Template, 5, 3, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(16, SessionChatCoachComponent_ng_template_16_Template, 2, 4, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(18, SessionChatCoachComponent_div_18_Template, 2, 2, "div", 12);
        i0.ɵɵtemplate(19, SessionChatCoachComponent_ng_template_19_Template, 1, 1, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(21, SessionChatCoachComponent_ng_template_21_Template, 2, 4, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelement(23, "jhi-alert");
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(5, _c10, ctx.showSessionSummary && !ctx.hideContent ? 0.3 : 1));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.session && ctx.isScreenXLg);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.session);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isScreenXLg);
        i0.ɵɵadvance(13);
        i0.ɵɵproperty("ngIf", ctx.showSessionSummary);
    } }, directives: [i13.NgStyle, i13.NgIf, i14.AlertComponent, i15.ScriptsComponent, i16.SessionControlComponent, i17.SessionMessageSendComponent, i13.NgClass, i18.JhiTranslateDirective, i19.UserInfoComponent, i20.ChatUiNewComponent, i21.EditActionPlanComponent, i22.MatTooltip, i23.CoachUserNoteComponent, i24.InukaJourneyCoachChatComponent, i25.FaIconComponent, i26.PreviousSessionTranscriptPopupComponent, i27.ModalSuccessComponent, i28.SessionSummaryComponent], pipes: [i10.TranslatePipe], styles: [".coach-session-chat-container[_ngcontent-%COMP%]{height:100vh;padding-top:60px}.white-button[_ngcontent-%COMP%]{border:1px solid #4ab197;display:block;margin:30px auto;background-color:#fff}.flex-column[_ngcontent-%COMP%]{background-color:#fff;border-radius:0px;position:relative !important}.modal-body[_ngcontent-%COMP%]{padding:0}.viewModeButtonActive[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#fff}.view-mode-parent[_ngcontent-%COMP%]{min-height:85%}.chat-container-coach[_ngcontent-%COMP%]{height:calc(100% - 50px)}.chat-container-coach-embed[_ngcontent-%COMP%]{height:calc(100% - 195px)}@media(min-width: 1200px){.view-mode-parent[_ngcontent-%COMP%]{min-height:100%}.coach-session-chat-container[_ngcontent-%COMP%]{padding-top:85px}.flex-column[_ngcontent-%COMP%]{border-radius:20px}}", "body[_ngcontent-%COMP%]{background-color:var(--bg-2) !important}.user-session-chat-container[_ngcontent-%COMP%]{padding:60px 0 0;margin-left:0;margin-right:0;width:100%}.chat-container[_ngcontent-%COMP%]{height:calc(100% - 110px)}.chat-container-embed[_ngcontent-%COMP%]{height:calc(100% - 195px)}.content-div[_ngcontent-%COMP%]{height:calc(100% - 40px)}.chat-ui-part-coach[_ngcontent-%COMP%]{background-color:#fff;border:1px solid rgba(0,0,0,.1);border-radius:20px;padding:5px;min-height:100%;position:relative !important}.chat-ui-part[_ngcontent-%COMP%]{background-color:#fff !important;border:none !important;border-radius:0;min-height:100%;position:relative !important}.action-plan-header[_ngcontent-%COMP%]{margin:20px !important}.action-plan-div-mobile[_ngcontent-%COMP%]{overflow-y:scroll !important;overflow-x:hidden !important;margin:20px !important;max-height:100% !important}.action-plan-div-pc[_ngcontent-%COMP%]{overflow-y:scroll !important;overflow-x:hidden !important;margin:20px !important;max-height:calc(100% - 150px) !important}.chat-ui-header[_ngcontent-%COMP%]{border-radius:0}chat-ui-new[_ngcontent-%COMP%]{height:100% !important}.switch-div[_ngcontent-%COMP%]{display:grid;grid-auto-columns:minmax(0, 1fr);grid-auto-flow:column}.chat-button[_ngcontent-%COMP%]{min-width:100% !important;border:none !important;border-radius:0}.action-plan-button[_ngcontent-%COMP%]{min-width:100% !important;border:none !important;border-radius:0}.your-session-started-header[_ngcontent-%COMP%]{margin:8px 12px 12px 12px !important;border:none !important;border-radius:5px !important}.your-session-started-text[_ngcontent-%COMP%]{padding:20px !important;margin:0 !important;font-weight:600 !important}.session-started-header[_ngcontent-%COMP%]{margin:8px 12px 12px 12px !important}.session-started-text[_ngcontent-%COMP%]{padding:7px !important;margin:0 !important;font-weight:normal !important;font-size:12px !important;color:#8a9d98 !important}.session-started-header[_ngcontent-%COMP%]{margin:0 12px !important}.session-started-text[_ngcontent-%COMP%]{margin:0 !important;font-weight:normal !important;font-size:12px !important;color:#8a9d98 !important}.rating-stars[_ngcontent-%COMP%]   .rating-stars-container[_ngcontent-%COMP%]   .rating-star[_ngcontent-%COMP%]{font-size:22px !important;padding:0 6px !important;color:#fff}.rating-star-hover[_ngcontent-%COMP%]{color:#44a38d}.star-icon[_ngcontent-%COMP%]{stroke:#44a38b;stroke-width:2}.feedback-text[_ngcontent-%COMP%]{text-decoration:underline !important;color:#44a38b !important;cursor:pointer !important;font-size:14px !important;margin:0 !important}[_nghost-%COMP%] .feedback-tool-tip{color:#fff !important;background:#44a38b !important;border:1px solid #44a38b !important;overflow:visible !important}[_nghost-%COMP%]  .feedback-tool-tip:before{content:\"\";position:absolute;top:-11px;left:50%;border-bottom:10px solid #44a38b;border-left:10px solid transparent;border-right:10px solid transparent;z-index:10000}.back-home-text[_ngcontent-%COMP%]{text-decoration:underline !important;color:#44a38b !important;cursor:pointer !important;font-size:14px !important;margin:0 !important}.book-follow-up[_ngcontent-%COMP%]{position:absolute !important;bottom:30px !important;left:50% !important;transform:translateX(-50%);z-index:1000 !important}.chat-progress-bar-horizontal[_ngcontent-%COMP%]{border-radius:10px !important;background-color:#f8f7f2;height:23px;width:275px;margin-top:5px;z-index:0}.progress-bar-tough-place[_ngcontent-%COMP%]{border-radius:20px 0 0 20px !important;display:inline-block;z-index:10;background-color:#b894aa}.progress-bar-at-risk[_ngcontent-%COMP%]{border-radius:0 0 0 0 !important;display:inline-block;z-index:10;background-color:#efe199}.progress-bar-resilient[_ngcontent-%COMP%]{border-radius:0 20px 20px 0 !important;display:inline-block;z-index:10;background-color:#a9d3c7}.number-circle[_ngcontent-%COMP%]{width:20px;height:20px;margin:2px 2px 2px auto}.s-resilient[_ngcontent-%COMP%]{position:absolute;color:#000;margin-top:.7rem;top:0;z-index:20;left:78.5%}.s-at-risk[_ngcontent-%COMP%]{position:absolute;color:#000;margin-top:.7rem;top:0;z-index:20;left:37%}.s-in-a-bad-place[_ngcontent-%COMP%]{position:absolute;color:#000;margin-top:.7rem;top:0;z-index:20;left:4.5%}.session-summary-icons[_ngcontent-%COMP%]{color:#8a9d98;cursor:pointer;margin-right:20px;margin-top:20px}.session-summary-icons[_ngcontent-%COMP%]   fa-icon[_ngcontent-%COMP%]{padding-left:5px}[_nghost-%COMP%]  .tooltip-inner{background:#f7eed2;color:#0a4a3a;text-align:left;border-radius:5px}[_nghost-%COMP%]  .arrow::before{border-top-color:#f7eed2 !important}[_nghost-%COMP%]  .popover{max-width:70% !important}.chat-progress-bar-horizontal[_ngcontent-%COMP%]{width:220px}@media(min-width: 576px){.chat-progress-bar-horizontal[_ngcontent-%COMP%]{width:275px}  .popover{max-width:25rem !important}}@media(min-width: 768px){.chat-progress-bar-horizontal[_ngcontent-%COMP%]{width:275px}.session-started-header[_ngcontent-%COMP%]{margin:0 12px !important}.session-started-text[_ngcontent-%COMP%]{font-size:14px !important}.back-home-text[_ngcontent-%COMP%]{font-size:16px !important;margin:0 !important}  .popover{max-width:25rem !important}}@media(min-width: 992px){.content-div[_ngcontent-%COMP%]{height:100% !important}.chat-progress-bar-horizontal[_ngcontent-%COMP%]{width:275px}  .popover{max-width:25rem !important}.user-session-chat-container[_ngcontent-%COMP%]{padding-bottom:1.5rem;padding-top:80px;padding-left:15px;padding-right:15px;margin-left:auto;margin-right:auto}.chat-ui-part[_ngcontent-%COMP%]{border-radius:20px !important}.chat-ui-header[_ngcontent-%COMP%]{border-top-left-radius:inherit;border-top-right-radius:inherit}}@media(min-width: 1200px){.chat-progress-bar-horizontal[_ngcontent-%COMP%]{width:275px}  .popover{max-width:25rem !important}}"] });
